<div class="custom-header">
  <button mat-icon-button class="_left" (click)="clicked()">
    <one-icon name="chevron-back-outline"></one-icon>
  </button>
  <span class="custom-header-label">{{periodLabel | titlecase}}</span>
  <div></div>
</div>
